import "./style.scss";
import ReportTab from "../../features/myReports/reportTab";
import React, {useEffect, useState} from "react";
import BatchReports from "../batchReports";
import {useDispatch, useSelector} from "react-redux";
import {getBatchReports} from "../../actions/reports";
import {checkSchoolReportsCount} from "../../utils/reports";
import NoReports from "../noReports";
import {userCanAccess} from "../../utils/users";

const FinalReports = (props) => {
  const {
    activeTab,
    studentReports,
    schoolReports,
    districtOverviewReports,
    additionalReports,
    schoolStatuses,
    batchReports,
    reportsDistrict,
    userComposite
  } = props;

  const [showBatchReport, setShowBatchReport] = useState(true);
  const [schoolCount, totalSchools] = checkSchoolReportsCount(schoolStatuses, 'Final');


  return (!schoolCount) ? <NoReports schoolCount={schoolCount} totalSchools={totalSchools} showSampleReports={false} reportType={'Final'} message={activeTab.noReportsMessage}/> : (
    <div className='final-report-container'>
      <div className='final-reports'>
        <ReportTab tabTitle={activeTab.title} studentReports={studentReports} schoolReports={schoolReports} districtOverviewReports={districtOverviewReports} additionalReports={additionalReports} data={activeTab.data} reportComponent={activeTab.reportComponent} setShowBatchReport={setShowBatchReport} reportType='Final' reportsDistrict={reportsDistrict}/>
      </div>
      {(showBatchReport && userCanAccess(userComposite, 'batch-reports')) ?
        <div className='batch-reports'>
          <BatchReports reports={batchReports} schoolStatuses={schoolStatuses} userComposite={userComposite}/>
        </div>
      : ''}
    </div>
  );
}

export default FinalReports;